import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { IconButton } from "../../buttons";
import { setCanvasProperty } from "../action";
import { translate } from "../../i18n";

function CanvasRecordButton({ t }) {
    if (!APP.layout.option.canvasRec) return null;

    const dispatch = useDispatch();
    const record = useSelector(state => state["features/base/canvas"].record);
    const onClick = () => {
        const isRecord = record ? false : true;
        
        dispatch(setCanvasProperty({record: isRecord}));

        APP.UI.closeModal();
    }
    return (
        <IconButton mode="canvasRec" size={22}  name={record ? t("options.shareRecordEnd") : t("options.shareRecordStart")} onClick={onClick} />
    );
}

export default translate(CanvasRecordButton);